import { Card, Col, CardHeader, CardBody, Row } from "reactstrap";
import { MoreVertical } from "react-feather";
import { HOBBIES_DATA } from "../../../../Data/SocialApp";
import { H3, P } from "../../../../AbstractElements";
import { HobbiesAndInterest } from "../../../../Constant";

const HobbiesAndInterests = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeader className="social-header">
          <H3>{HobbiesAndInterest}<span className="pull-right"><MoreVertical /></span></H3>
        </CardHeader>
        <CardBody>
          {HOBBIES_DATA.map((data, index) => (
            <Row className="details-about" key={index}>
              <Col sm="6">
                <div className="your-details">
                  <span className="f-w-600">{data.heading1}</span>
                  <P>{data.paragraph1}</P>
                </div>
              </Col>
              <Col sm="6">
                <div className="your-details your-details-xs">
                  <span className="f-w-600">{data.heading2}</span>
                  <P>{data.paragraph2}</P>
                </div>
              </Col>
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HobbiesAndInterests;
